// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReassignModal-module__modalOverlay___Yq2W_ {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.ReassignModal-module__modalCard___FR_cV {
  width: 100%;
  max-width: 480px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.ReassignModal-module__modalHeader____lGwz {
  padding: 16px 18px 14px;
  border-bottom: 1px solid #e5e7eb;
}

.ReassignModal-module__modalTitle___HPfG2 {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.ReassignModal-module__modalSubtitle___T1reP {
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.4;
  color: #6b7280;
  white-space: nowrap;
}

.ReassignModal-module__modalBody___kjbna {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.ReassignModal-module__modalText___aoEWp {
  margin: 6px 0 0;
  font-size: 12px;
  color: #52525b;
  line-height: 1.5;
}

.ReassignModal-module__searchInput___iREus {
  width: 100%;
  font-size: 14px;
  line-height: 1.5;
  color: #111827;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  padding: 8px 10px;
  transition: border-color 0.15s ease;
}

.ReassignModal-module__searchInput___iREus:focus {
  outline: none;
  border-color: #a1a1aa;
}

.ReassignModal-module__userPicker___sf809 {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.ReassignModal-module__searchWrap___EcarG {
  padding: 14px 16px 10px;
  border-bottom: 1px solid #e5e7eb;
  background: #ffffff;
}

.ReassignModal-module__teamSections___xajeH {
  flex: 1 1 auto;
  max-height: 320px;
  overflow-y: auto;
  background: #fafafa;
}

.ReassignModal-module__teamSection___oq_UV {
  border-bottom: 1px solid #f4f4f5;
  background: #fafafa;
}

.ReassignModal-module__teamSection___oq_UV:last-child {
  border-bottom: none;
}

.ReassignModal-module__teamSectionHeader___cAMTP {
  width: 100%;
  padding: 11px 16px;
  border: none;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;
}

.ReassignModal-module__teamSectionHeader___cAMTP:hover {
  background: #f4f4f5;
}

.ReassignModal-module__teamSectionLeft___wNFVG {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.ReassignModal-module__teamSectionChevron___uOD45 {
  width: 10px;
  text-align: center;
  font-size: 11px;
  color: #9ca3af;
  transition: transform 0.15s ease;
  flex-shrink: 0;
}

.ReassignModal-module__teamSectionChevronOpen___u1j_E {
  transform: rotate(90deg);
}

.ReassignModal-module__teamSectionIcon___Tso1J {
  font-size: 11px;
  color: #6b7280;
  line-height: 1;
}

.ReassignModal-module__teamSectionTitle___xsFE8 {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.3;
}

.ReassignModal-module__teamSectionCount___clFLo {
  font-size: 12px;
  color: #6b7280;
  line-height: 1;
}

.ReassignModal-module__teamSectionList___qb9Xv {
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.ReassignModal-module__teamSectionList___qb9Xv > .ReassignModal-module__teamMemberRow___eYmhD + .ReassignModal-module__teamMemberRow___eYmhD {
  border-top: 1px solid #eef2f7;
}

.ReassignModal-module__teamSectionEmpty___hNss8 {
  padding: 16px 20px;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
}

.ReassignModal-module__teamMemberRow___eYmhD {
  width: 100%;
  padding: 10px 16px;
  border: none;
  border-left: 2px solid transparent;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.ReassignModal-module__teamMemberRow___eYmhD:disabled {
  cursor: default;
  opacity: 0.6;
}

.ReassignModal-module__teamMemberRow___eYmhD:not(:disabled):hover {
  background: #f4f6f8;
}

.ReassignModal-module__teamMemberRowActive___WICvS {
  background: #eef2f7;
  border-left-color: #6b7280;
}

.ReassignModal-module__teamMemberAvatar___D4ZHT {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}

.ReassignModal-module__teamMemberInfo___cOhPK {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ReassignModal-module__teamMemberName___t9fDF {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.ReassignModal-module__teamMemberRole____Go_Y {
  font-size: 11px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.ReassignModal-module__teamMemberBadge___JPDHd {
  flex-shrink: 0;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 3px 7px;
  font-size: 11px;
  color: #6b7280;
  background: #ffffff;
}

.ReassignModal-module__currentOwnerTag___WVSEU {
  font-size: 10px;
  font-weight: 600;
  color: #52525b;
  border: 1px solid #d4d4d8;
  border-radius: 999px;
  padding: 2px 7px;
}

.ReassignModal-module__modalFooter___Wh5op {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.ReassignModal-module__modalSecondaryAction___uNOXd {
  min-width: 64px;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #4b5563;
  cursor: pointer;
}

.ReassignModal-module__modalSecondaryAction___uNOXd:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.ReassignModal-module__modalPrimaryAction___A5Awx {
  min-width: 64px;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  background: #1f2937;
  color: #ffffff;
  cursor: pointer;
}

.ReassignModal-module__modalPrimaryAction___A5Awx:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: default;
}

.ReassignModal-module__modalPrimaryAction___A5Awx:focus-visible,
.ReassignModal-module__teamSectionHeader___cAMTP:focus-visible,
.ReassignModal-module__teamMemberRow___eYmhD:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ReassignModal/ReassignModal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,gCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mCAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;EACE,uBAAA;EACA,gCAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gCAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;EACA,cAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,0DACE;AAAJ;;AAIA;EACE,eAAA;EACA,YAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,mBAAA;EACA,0BAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,YAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,0BAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;;;EAGE,0BAAA;EACA,mBAAA;AADF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.modalCard {\n  width: 100%;\n  max-width: 480px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n.modalHeader {\n  padding: 16px 18px 14px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modalTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.modalSubtitle {\n  margin-top: 4px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n.modalBody {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.modalText {\n  margin: 6px 0 0;\n  font-size: 12px;\n  color: #52525b;\n  line-height: 1.5;\n}\n\n.searchInput {\n  width: 100%;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #111827;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n  padding: 8px 10px;\n  transition: border-color 0.15s ease;\n}\n\n.searchInput:focus {\n  outline: none;\n  border-color: #a1a1aa;\n}\n\n.userPicker {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.searchWrap {\n  padding: 14px 16px 10px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #ffffff;\n}\n\n.teamSections {\n  flex: 1 1 auto;\n  max-height: 320px;\n  overflow-y: auto;\n  background: #fafafa;\n}\n\n.teamSection {\n  border-bottom: 1px solid #f4f4f5;\n  background: #fafafa;\n}\n\n.teamSection:last-child {\n  border-bottom: none;\n}\n\n.teamSectionHeader {\n  width: 100%;\n  padding: 11px 16px;\n  border: none;\n  background: #fafafa;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.15s ease;\n}\n\n.teamSectionHeader:hover {\n  background: #f4f4f5;\n}\n\n.teamSectionLeft {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.teamSectionChevron {\n  width: 10px;\n  text-align: center;\n  font-size: 11px;\n  color: #9ca3af;\n  transition: transform 0.15s ease;\n  flex-shrink: 0;\n}\n\n.teamSectionChevronOpen {\n  transform: rotate(90deg);\n}\n\n.teamSectionIcon {\n  font-size: 11px;\n  color: #6b7280;\n  line-height: 1;\n}\n\n.teamSectionTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2937;\n  line-height: 1.3;\n}\n\n.teamSectionCount {\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1;\n}\n\n.teamSectionList {\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n}\n\n.teamSectionList > .teamMemberRow + .teamMemberRow {\n  border-top: 1px solid #eef2f7;\n}\n\n.teamSectionEmpty {\n  padding: 16px 20px;\n  font-size: 13px;\n  color: #6b7280;\n  text-align: center;\n}\n\n.teamMemberRow {\n  width: 100%;\n  padding: 10px 16px;\n  border: none;\n  border-left: 2px solid transparent;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-align: left;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.teamMemberRow:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n\n.teamMemberRow:not(:disabled):hover {\n  background: #f4f6f8;\n}\n\n.teamMemberRowActive {\n  background: #eef2f7;\n  border-left-color: #6b7280;\n}\n\n.teamMemberAvatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.teamMemberInfo {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.teamMemberName {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2937;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.3;\n}\n\n.teamMemberRole {\n  font-size: 11px;\n  color: #6b7280;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.3;\n}\n\n.teamMemberBadge {\n  flex-shrink: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  padding: 3px 7px;\n  font-size: 11px;\n  color: #6b7280;\n  background: #ffffff;\n}\n\n.currentOwnerTag {\n  font-size: 10px;\n  font-weight: 600;\n  color: #52525b;\n  border: 1px solid #d4d4d8;\n  border-radius: 999px;\n  padding: 2px 7px;\n}\n\n.modalFooter {\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.modalSecondaryAction {\n  min-width: 64px;\n  padding: 6px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #d4d4d8;\n  background: #ffffff;\n  color: #4b5563;\n  cursor: pointer;\n}\n\n.modalSecondaryAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.modalPrimaryAction {\n  min-width: 64px;\n  padding: 6px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: none;\n  background: #1f2937;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.modalPrimaryAction:disabled {\n  background: #e5e7eb;\n  color: #9ca3af;\n  cursor: default;\n}\n\n.modalPrimaryAction:focus-visible,\n.teamSectionHeader:focus-visible,\n.teamMemberRow:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `ReassignModal-module__modalOverlay___Yq2W_`,
	"modalCard": `ReassignModal-module__modalCard___FR_cV`,
	"modalHeader": `ReassignModal-module__modalHeader____lGwz`,
	"modalTitle": `ReassignModal-module__modalTitle___HPfG2`,
	"modalSubtitle": `ReassignModal-module__modalSubtitle___T1reP`,
	"modalBody": `ReassignModal-module__modalBody___kjbna`,
	"modalText": `ReassignModal-module__modalText___aoEWp`,
	"searchInput": `ReassignModal-module__searchInput___iREus`,
	"userPicker": `ReassignModal-module__userPicker___sf809`,
	"searchWrap": `ReassignModal-module__searchWrap___EcarG`,
	"teamSections": `ReassignModal-module__teamSections___xajeH`,
	"teamSection": `ReassignModal-module__teamSection___oq_UV`,
	"teamSectionHeader": `ReassignModal-module__teamSectionHeader___cAMTP`,
	"teamSectionLeft": `ReassignModal-module__teamSectionLeft___wNFVG`,
	"teamSectionChevron": `ReassignModal-module__teamSectionChevron___uOD45`,
	"teamSectionChevronOpen": `ReassignModal-module__teamSectionChevronOpen___u1j_E`,
	"teamSectionIcon": `ReassignModal-module__teamSectionIcon___Tso1J`,
	"teamSectionTitle": `ReassignModal-module__teamSectionTitle___xsFE8`,
	"teamSectionCount": `ReassignModal-module__teamSectionCount___clFLo`,
	"teamSectionList": `ReassignModal-module__teamSectionList___qb9Xv`,
	"teamMemberRow": `ReassignModal-module__teamMemberRow___eYmhD`,
	"teamSectionEmpty": `ReassignModal-module__teamSectionEmpty___hNss8`,
	"teamMemberRowActive": `ReassignModal-module__teamMemberRowActive___WICvS`,
	"teamMemberAvatar": `ReassignModal-module__teamMemberAvatar___D4ZHT`,
	"teamMemberInfo": `ReassignModal-module__teamMemberInfo___cOhPK`,
	"teamMemberName": `ReassignModal-module__teamMemberName___t9fDF`,
	"teamMemberRole": `ReassignModal-module__teamMemberRole____Go_Y`,
	"teamMemberBadge": `ReassignModal-module__teamMemberBadge___JPDHd`,
	"currentOwnerTag": `ReassignModal-module__currentOwnerTag___WVSEU`,
	"modalFooter": `ReassignModal-module__modalFooter___Wh5op`,
	"modalSecondaryAction": `ReassignModal-module__modalSecondaryAction___uNOXd`,
	"modalPrimaryAction": `ReassignModal-module__modalPrimaryAction___A5Awx`
};
module.exports = ___CSS_LOADER_EXPORT___;
